import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { SDKMessageComponent } from './sdk-message.component';

@NgModule({
  imports: [
    SDKMessageComponent
  ],
  exports: [
    SDKMessageComponent
  ],
  schemas: [
    NO_ERRORS_SCHEMA
  ]
})

export class SDKMessageModule { }
